export const formatDistance = (value: number, locale: string) =>
  `${value.toLocaleString(locale, { maximumFractionDigits: 1 })} km`
